/* ============================================================
   SHOPIFY CONFIG
   Mirrors C:\Users\jcarr\Desktop\Dev\FCC Dashboard\src\lib\orderTypes.ts
   exactly — same product/variant IDs the internal Sales Dashboard
   "Create Order" flow already uses, so an order placed from this
   storefront builder lands in the dashboard the same way a
   rep-built draft order does. If orderTypes.ts ever changes, copy
   the new values here too (or replace this file with a real fetch
   of it later).

   Product: "Full Coverage Custom Seat Covers" (id 9896380924213)
   Every Order Type below is that product's "Custom Color" variant
   for that coverage tier — color/pattern/vehicle are NOT separate
   Shopify variants, they ride along as line-item properties
   (see buildLineItemProperties() in app.js), exactly like
   src/app/actions/sales-invoices.ts builds them today.
   ============================================================ */
const ORDER_TYPES = {
  'Full Set (Front + Back)': { variantId: 50713197314357, price: 650 },
  'Fronts Only':             { variantId: 50713197281589, price: 490 },
  'Backs Only':              { variantId: 50798406631733, price: 380 }
};
const EXTRA_SEAT_VARIANT_ID = 50745238126901;
const EXTRA_SEAT_PRICE = 150;
// Front Middle Jump Seat add-on (created 2026-09-26): its own variant on the same product, named
// "Extra Seat - Front Middle Jump Seat" so the dashboard's Shopify webhook files it under Extra Seats.
const JUMP_SEAT_VARIANT_ID = 67577773687093;
const JUMP_SEAT_PRICE = 50;

// Real patterns (matches FCC Dashboard/public/images/patterns/*.png). Thumb
// images are GPT-Image-2.5-Sunburst vector-style renders of the real
// fabric patterns, restyled into the builder's cream/gold colorway —
// see patterns/ in this project folder.
const PATTERNS = [
  { id: 'Diamond', name: 'Diamond', thumb: 'patterns/diamond.webp' },
  { id: 'Basic', name: 'Basic', thumb: 'patterns/basic.webp' }
];

// Real color list — pulled directly from the same Supabase `colors` table
// the dashboard's CreateOrderModal reads (`is_available = true`), same
// fields (code, name, swatchUrl), same solid-color filter (excludes any
// combo name with '&', '/', '+', or "two tone" in it — there are none of
// those in this table today, but the filter is kept for parity).
// Swatch images: recoloured to the locked targets, then shrunk to 96px WebP (2026-09-26) in
// ./swatches/ in this project. Re-pull from Supabase if colors change.
const COLORS_RAW = [
  { code: '3998-003', name: 'Aqua Blue', swatchUrl: 'swatches/3998-003.webp', eligibleStitchingPiping: false },
  { code: '3998-12', name: 'Beige', swatchUrl: 'swatches/3998-12.webp', eligibleStitchingPiping: false },
  { code: '3998-1', name: 'Black', swatchUrl: 'swatches/3998-1.webp', eligibleStitchingPiping: true },
  { code: '3998-068', name: 'Charcoal Grey', swatchUrl: 'swatches/3998-068.webp', eligibleStitchingPiping: true },
  { code: '3998-7', name: 'Dark Mocha', swatchUrl: 'swatches/3998-7.webp', eligibleStitchingPiping: false },
  { code: '3998-13', name: 'Dark Orange', swatchUrl: 'swatches/3998-13.webp', eligibleStitchingPiping: true },
  { code: '3998-136', name: 'Dark Purple', swatchUrl: 'swatches/3998-136.webp', eligibleStitchingPiping: true },
  { code: '3998-19', name: 'Dark Saddle Brown', swatchUrl: 'swatches/3998-19.webp', eligibleStitchingPiping: false },
  { code: '3998-009', name: 'Deep Teal', swatchUrl: 'swatches/3998-009.webp', eligibleStitchingPiping: false },
  { code: '3998-106', name: 'Espresso Brown', swatchUrl: 'swatches/3998-106.webp', eligibleStitchingPiping: false },
  { code: '3998-013', name: 'Golden Yellow', swatchUrl: 'swatches/3998-013.webp', eligibleStitchingPiping: true },
  { code: '3998-015', name: 'Lavender', swatchUrl: 'swatches/3998-015.webp', eligibleStitchingPiping: false },
  { code: '3998-060', name: 'Light Grey', swatchUrl: 'swatches/3998-060.webp', eligibleStitchingPiping: true },
  { code: '3998-004', name: 'Lime Green', swatchUrl: 'swatches/3998-004.webp', eligibleStitchingPiping: false },
  { code: '3998-9', name: 'Mid Grey', swatchUrl: 'swatches/3998-9.webp', eligibleStitchingPiping: true },
  { code: '3998-14', name: 'Midnight Blue', swatchUrl: 'swatches/3998-14.webp', eligibleStitchingPiping: true },
  { code: '3998-114', name: 'Olive Green', swatchUrl: 'swatches/3998-114.webp', eligibleStitchingPiping: false },
  { code: '3998-006', name: 'Orange', swatchUrl: 'swatches/3998-006.webp', eligibleStitchingPiping: true },
  { code: '3998-080', name: 'Peanut Butter', swatchUrl: 'swatches/3998-080.webp', eligibleStitchingPiping: false },
  { code: '3998-18', name: 'Pink', swatchUrl: 'swatches/3998-18.webp', eligibleStitchingPiping: false },
  { code: '3998-2', name: 'Red', swatchUrl: 'swatches/3998-2.webp', eligibleStitchingPiping: true },
  { code: '3998-014', name: 'Royal Blue', swatchUrl: 'swatches/3998-014.webp', eligibleStitchingPiping: true },
  { code: '3998-8', name: 'Saddle Brown', swatchUrl: 'swatches/3998-8.webp', eligibleStitchingPiping: false },
  { code: '3998-061', name: 'Sage Grey', swatchUrl: 'swatches/3998-061.webp', eligibleStitchingPiping: true },
  { code: '3998-62', name: 'Sand', swatchUrl: 'swatches/3998-62.webp', eligibleStitchingPiping: false },
  { code: '3998-22', name: 'Sky Blue', swatchUrl: 'swatches/3998-22.webp', eligibleStitchingPiping: false },
  { code: '3998-010', name: 'Slate Blue', swatchUrl: 'swatches/3998-010.webp', eligibleStitchingPiping: false },
  { code: '3998-063', name: 'Slate Grey', swatchUrl: 'swatches/3998-063.webp', eligibleStitchingPiping: true },
  { code: '3998-012', name: 'Soft Plum', swatchUrl: 'swatches/3998-012.webp', eligibleStitchingPiping: false },
  { code: '3998-064', name: 'Steel Blue', swatchUrl: 'swatches/3998-064.webp', eligibleStitchingPiping: true },
  { code: '3998-6', name: 'Warm Khaki', swatchUrl: 'swatches/3998-6.webp', eligibleStitchingPiping: false },
  { code: '3998-002', name: 'White', swatchUrl: 'swatches/3998-002.webp', eligibleStitchingPiping: true },
  { code: '3998-3', name: 'Wine Red', swatchUrl: 'swatches/3998-3.webp', eligibleStitchingPiping: true }
];

const COLORS = COLORS_RAW.filter(c =>
  !c.name.includes('&') &&
  !c.name.toLowerCase().includes('two tone') &&
  !c.name.includes('/') &&
  !c.name.includes('+')
);

// On the live store the theme section sets window.FCC_DESIGNER. Swatch and pattern images are then theme
// assets with flat names (the theme assets folder has no subfolders).
if (window.FCC_DESIGNER) {
  const b = window.FCC_DESIGNER.assetBase;
  // Theme assets are cached for a year, so a re-coloured swatch (e.g. Mid Grey, 2026-09-28) would stay stale for
  // returning visitors; the build stamp from build_theme.js makes each deploy fetch fresh copies.
  const v = window.FCC_DESIGNER.assetVersion ? '?v=' + window.FCC_DESIGNER.assetVersion : '';
  COLORS.forEach(c => { c.swatchUrl = b + 'fcc-sw-' + c.code + '.webp' + v; });
  PATTERNS.forEach(p => { p.thumb = b + 'fcc-pattern-' + p.id.toLowerCase() + '.webp' + v; });
}

// FAQ under the preview (Jesse, 2026-09-27): the Top 10 Trust Objections from the Jul to Sep 2026 lead research,
// answered only with facts Jesse confirmed (Objection Reports/Trust Content Scripts "Confirmed facts sheet").
// Delivery times are Jesse's own wording from 2026-09-27. Customer-facing copy: no em-dashes.
const FAQS = [
  {
    q: 'Why do your covers cost more than others I have seen?',
    a: [
      'Cheaper covers exist, and here is what the difference buys you. Universal covers are built to fit every seat, so they fit none properly: they slide, bunch and look like a cover. Tailored kits get closer, but are usually vinyl, picked from a short vehicle list, with back seats that rarely fit.',
      'Ours are made to order for your exact seats, measured from photos of your seats with our 3D scanning software, in genuine Nappa leather with a memory foam lining. Prefer to spread it out? Affirm splits your order into 4 interest-free payments, and we accept PayPal too.'
    ]
  },
  {
    q: 'Is First Class Covers a real company?',
    a: [
      'Yes. Your covers are made in our own factory, then shipped to our warehouse in Tennessee, where every set is quality checked and stress tested. No order ships without passing.',
      'You pay through a secure checkout with card, PayPal or Affirm, with full buyer protection. Questions any time: text or call our support line at 865-353-9587, or email support@firstclasscovers.com.'
    ]
  },
  {
    q: 'Will these actually fit my seats?',
    a: [
      'We have personally scanned over 7,000 seat configurations, the largest 100% digital seat database in the industry, so we can make fully custom covers, fronts and backs, for almost any vehicle. After you order, you upload photos of your actual seats in your customer portal, and our 3D image scanning software takes accurate measurements from them. Measure twice, cut once.',
      'The spots where seat covers usually go wrong are headrests, the cutouts for levers and seat belts, the middle jump seat and the console lid, so those are exactly the parts we ask you to photograph. We make a separate cover for each section of a split seat, so your seats still fold. Other companies cover the whole seat with Velcro flaps, which takes away the folding.'
    ]
  },
  {
    q: 'What happens if they do not fit?',
    a: [
      'Send us photos of the fitment issue within 30 days of delivery and we remake your covers for free, correcting the problem. In most cases no return is needed. If they still do not fit after the remake, we refund you.',
      'Every set also comes with a 1-year warranty, with upgrade options available.'
    ]
  },
  {
    q: 'I have seen some bad reviews. What is the story?',
    a: [
      'We make every set from photos, for thousands of different seats, and sometimes a piece comes out wrong. When it does, we remake it for free, and if it still does not fit, we refund. Most customers are happy with how we handle it. A few are not, and we would rather you see that than have it hidden.',
      'Most of our customers never post a public review. They text us, often with a photo of their seats. Want to see our covers on a vehicle like yours? Text 865-353-9587 and we will send real photos.'
    ]
  },
  {
    q: 'I have been burned by seat covers before. How is this different?',
    a: [
      'Most covers are made for a category of vehicle, not your vehicle. That is why they slide, block your buttons and armrests, and treat the back seats as an afterthought.',
      'Ours are measured from photos of your seats, made with full coverage fitment front and back, in genuine Nappa leather. If anything does not fit, you get a free remake, and a refund if it still does not. After you pay, you have real people to talk to: your rep, our support line and your customer portal.'
    ]
  },
  {
    q: 'How long does delivery take?',
    a: [
      'Your covers do not exist yet. Every set is made from scratch for your seats after you order, then quality checked and stress tested before it ships.',
      '<strong>Standard Delivery:</strong> 4 to 5 weeks production, 7 to 10 days shipping.<br><strong>Priority Delivery:</strong> 2 to 3 weeks production, 7 days shipping.',
      'Delivery time is subject to change based on how many orders are in the queue. During busy seasons, we will let you know if delivery time is extended. You can follow your order in your customer portal, and you get a tracking email the day it ships.'
    ]
  },
  {
    q: 'Is it real leather? Where is it made?',
    a: [
      'Yes, it is genuine Nappa leather, with added waterproofing and scratch resistance, perforated for breathability, over a memory foam lining.',
      'Your covers are made in our own factory in China. Owning the factory is how we make custom leather sets at a fair price instead of $2,000 or more. Every set then comes to our Tennessee warehouse to be quality checked and stress tested before it ships.'
    ]
  },
  {
    q: 'What exactly happens after I order?',
    a: [
      '<strong>1.</strong> You check out securely with card, PayPal or Affirm.<br><strong>2.</strong> You upload photos of your seats in your customer portal within 7 days.<br><strong>3.</strong> Our 3D scanning software measures them and your set is made in our factory.<br><strong>4.</strong> It is quality checked and stress tested at our Tennessee warehouse.<br><strong>5.</strong> It ships to you with tracking.',
      'Every rep on our team follows this same process. Questions any time: 865-353-9587 or support@firstclasscovers.com.'
    ]
  },
  {
    q: 'Can I install them myself?',
    a: [
      'Yes. The covers go right over your existing seats, and nothing gets removed or stitched on your original seats. Each section of a split seat gets its own cover, so your seats still fold.',
      'If you get stuck at any point, text a photo to 865-353-9587 and we will walk you through it.'
    ]
  },
  {
    q: 'Will my heated seats, cooled seats and airbags still work?',
    a: [
      'Yes. Our covers are designed to work with your heated and ventilated seats. The Nappa leather is perforated, so heat and air still come through and the seats stay breathable and comfortable.',
      'If your seats have side airbags, we stitch the airbag side of the cover so the airbag can deploy right through it.'
    ]
  }
];
